@if (opportunity$ | async; as opportunity) {
    <div>
        <mat-card style="margin-bottom: 10px">
            <div class="details-container">
                <div class="opportunity-info">
                    <div class="opportunity-header">
                        <div class="opportunity-title-group">
                            <span mat-card-title>{{ opportunity.opportunityName }}</span>
                            @if (opportunity.budgetNr) {
                                <span class="link"
                                      [routerLink]="['/budget',opportunity.budgetId]">{{ opportunity.budgetNr }}</span>
                            }
                            @if (!opportunity.budgetNr) {
                                <span>Budget not created yet!</span>
                            }
                            @if (opportunity.isChangeOrder) {
                                <span>(Change order)</span>
                            }
                        </div>
                        @if (opportunity.status === OpportunityStatuses.IN_PROGRESS) {
                            <button mat-icon-button [matMenuTriggerFor]="opportunityMenu"
                            >
                                <mat-icon>more_vert</mat-icon>
                            </button>
                        }
                        <mat-menu #opportunityMenu="matMenu">
                            <app-opportunity-contextual-menu [opportunity]="opportunity"
                            ></app-opportunity-contextual-menu>
                        </mat-menu>
                    </div>
                    <div class="info-rows">
                        <div class="info-row">
                            <div class="info-item">
                                <span class="info-label">Status:</span>
                                <strong class="info-value">
                                    <app-display-value
                                            [value]="selectedFollowUp ? selectedFollowUp.status : opportunity.status"></app-display-value>
                                </strong>
                            </div>
                            <div class="info-item">
                                <span class="info-label">Stage:</span>
                                <strong class="info-value">
                                    <app-display-value
                                            [value]="selectedFollowUp ? selectedFollowUp.opportunityStage : opportunity.opportunityStage"></app-display-value>
                                </strong>
                            </div>
                            @if (selectedFollowUp?.lostBecause || opportunity.lostBecause) {
                                <div class="info-item">
                                    <span class="info-label">Reason:</span>
                                    <strong class="info-value">
                                        <app-display-value
                                                [value]="selectedFollowUp ? selectedFollowUp.lostBecause : opportunity.lostBecause"></app-display-value>
                                    </strong>
                                </div>
                            }
                        </div>
                        <div class="info-row">
                            <div class="info-item">
                                <span class="info-label">Proposal requested:</span>
                                <strong class="info-value">
                                    <app-display-value
                                            [value]="selectedFollowUp ? selectedFollowUp.proposalRequested : opportunity.proposalRequested"
                                            pipeType="date" pipeArgs="dd/MM/yyyy"></app-display-value>
                                </strong>
                            </div>
                            <div class="info-item">
                                <span class="info-label">Proposal sent on:</span>
                                <strong class="info-value">
                                    <app-display-value
                                            [value]="selectedFollowUp ? selectedFollowUp.proposalSentOn : opportunity.proposalSentOn"
                                            pipeType="date" pipeArgs="dd/MM/yyyy"></app-display-value>
                                </strong>
                            </div>
                        </div>
                        <div class="info-row">
                            <div class="info-item">
                                <span class="info-label">Potential closure:</span>
                                <strong class="info-value">
                                    <app-display-value
                                            [value]="selectedFollowUp ? selectedFollowUp.potentialClosureQuarter : opportunity.potentialClosureQuarter"></app-display-value>
                                    -
                                    <app-display-value
                                            [value]="selectedFollowUp ? selectedFollowUp.potentialClosureYear : opportunity.potentialClosureYear"></app-display-value>
                                </strong>
                            </div>
                            @if (opportunity.currency === 'EUR') {
                                <div class="info-item">
                                    <span class="info-label">Forecast amount:</span>
                                    <strong class="info-value">
                                        <app-display-value
                                                [value]="selectedFollowUp ? selectedFollowUp.forecastAmountITA : opportunity.forecastAmountITA"
                                                pipeType="currency" pipeArgs="'EUR'"></app-display-value>
                                    </strong>
                                </div>
                            }
                            @if (opportunity.currency === 'USD') {
                                <div class="info-item">
                                    <span class="info-label">Forecast amount:</span>
                                    <strong class="info-value">
                                        <app-display-value
                                                [value]="selectedFollowUp ? selectedFollowUp.forecastAmountUSA : opportunity.forecastAmountUSA"
                                                pipeType="currency" pipeArgs="'USD'"></app-display-value>
                                    </strong>
                                </div>
                            }
                        </div>
                        <div class="info-row">
                            <div class="info-item">
                                <span class="info-label">Sales manager:</span>
                                <strong class="info-value">
                                    <app-display-value [value]="opportunity.salesManager"></app-display-value>
                                </strong>
                            </div>
                            <div class="info-item">
                                <span class="info-label">Created by:</span>
                                <strong class="info-value">
                                    <app-display-value [value]="opportunity.createdBy"></app-display-value>
                                </strong>
                            </div>
                        </div>
                        <div class="info-item full-width">
                            <span class="info-label">Next steps:</span>
                            <strong class="info-value">
                                <app-display-value
                                        [value]="selectedFollowUp ? selectedFollowUp.nextSteps : opportunity.nextSteps"></app-display-value>
                            </strong>
                        </div>
                    </div>
                </div>
                <div class="company-details-card">
                    @if (company$ | async; as company) {
                        <mat-card>
                            <mat-card-header class="company-card-header">
                                <div class="company-card-title-group">
                                    <mat-card-title>{{ company.name }}</mat-card-title>
                                    <mat-card-subtitle>
                                        <app-display-value [value]="company.address?.street"></app-display-value>
                                        ,
                                        <app-display-value [value]="company.address?.city"></app-display-value>
                                        ,
                                        <app-display-value [value]="company.address?.country"></app-display-value>
                                    </mat-card-subtitle>
                                </div>
                                <button mat-icon-button (click)="openChangeCompanyDialog(opportunity)" matTooltip="Change client">
                                    <mat-icon>edit</mat-icon>
                                </button>
                            </mat-card-header>
                            <mat-card-content class="company-details-grid">
                                <div class="info-item">
                                    <span class="info-label">Sector</span>
                                    <strong class="info-value">
                                        <app-display-value [value]="opportunity.sector"></app-display-value>
                                    </strong>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Customer Type</span>
                                    <strong class="info-value">
                                        <app-display-value [value]="opportunity.customerType"></app-display-value>
                                    </strong>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Primary Contact</span>
                                    <strong class="info-value">
                                        <app-display-value [value]="company.primaryContact?.name"></app-display-value>
                                    </strong>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Email</span>
                                    <strong class="info-value">
                                        <app-display-value
                                                [value]="company.primaryContact?.emails?.[0]?.email"></app-display-value>
                                    </strong>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Phone</span>
                                    <strong class="info-value">
                                        <app-display-value
                                                [value]="company.primaryContact?.phone_numbers?.[0]?.number"></app-display-value>
                                    </strong>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    } @else if (opportunity.companyId) {
                        <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                            <mat-spinner></mat-spinner>
                        </div>
                    } @else {
                        <mat-card>
                            <mat-card-header class="company-card-header">
                                <div class="company-card-title-group">
                                    <mat-card-title>No client assigned</mat-card-title>
                                    <mat-card-subtitle>Assign a client to this opportunity</mat-card-subtitle>
                                </div>
                                <button mat-icon-button (click)="openChangeCompanyDialog(opportunity)" matTooltip="Change client">
                                    <mat-icon>edit</mat-icon>
                                </button>
                            </mat-card-header>
                        </mat-card>
                    }
                </div>
            </div>
        </mat-card>
        <app-follow-ups-list [opportunity]="opportunity"
                             (followUpSelected)="onFollowUpSelection($event)"></app-follow-ups-list>
    </div>
} @else {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

